import { useUserStore } from "shared/store";
import { signOut } from "firebase/auth";
import { auth } from "firebase.config";

export const useLogOut = () => {
  const removeUser = useUserStore((state) => state.removeUser);

  const logout = async () => {
    // Clear ALL storage FIRST to prevent any restoration attempts
    // This includes Firebase's internal auth persistence keys
    localStorage.clear();
    sessionStorage.clear();

    // Clear Zustand store state
    removeUser();

    // Sign out from Firebase - this invalidates the current session
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error signing out from Firebase:", error);
    }

    // Force a full page reload to ensure clean state
    // This is more reliable than client-side navigation after auth changes
    // Note: The full page reload naturally resets the React Query cache
    window.location.href = "/login";
  };

  return logout;
};
